import { render, staticRenderFns } from "./GroupCreate.vue?vue&type=template&id=730bf913&scoped=true&"
import script from "./GroupCreate.vue?vue&type=script&lang=js&"
export * from "./GroupCreate.vue?vue&type=script&lang=js&"
import style1 from "./GroupCreate.vue?vue&type=style&index=1&id=730bf913&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730bf913",
  null
  
)

export default component.exports